import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ForgotPasswordActions } from '../actions';
import { errors as directoryErrors, Directory } from '@smash-sdk/directory/ejs/11-2023';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable()
export class ForgotPasswordEffects {

    forgotPassword$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ForgotPasswordActions.forgotPassword),
            switchMap((action) => {
                const directorySdk = new Directory();
                return from(directorySdk.forgotPassword({ username: action.email })).pipe(
                    map(() => {
                        return ForgotPasswordActions.forgotPasswordSuccess();
                    }),
                    catchError((error: HttpErrorResponse) => {
                        if (error instanceof directoryErrors.ForgotPasswordError.NotFoundError) {
                            return of(ForgotPasswordActions.forgotPasswordFailure({ error: 'SIGNIN_ALERT_MESSAGE_EMAIL_NOT_FOUND' }));
                        }
                        return of(ForgotPasswordActions.forgotPasswordFailure({ error: error.message }))
                    })
                )
            }
            )
        )
    );

    constructor(
        private actions$: Actions,
    ) { }
}
